export const hosing_Legal_bot = [
  {
    id: 1,
    name: 'Communal Property Associates Act.pdf',
    summary: 'shortsummary/Communal Property Associations Act.html',
    link: 'communal Property Associates Act.pdf',
    audio_en: 'audio/en/communal Property Associates Act_en.mp3',
    audio_af: 'audio/af/communal Property Associates Act_af.mp3',
    audio_xh: 'audio/xh/communal Property Associates Act_xh.mp3'
  },
  {
    id: 2,
    name: 'Community Schemes Ombud Service Act 2011',
    summary: 'shortsummary/Community_Schemes_Ombud_Service Act_2011.html',
    link: 'Community_Schemes_Ombud_Service Act.pdf',
    audio_en: 'audio/en/Community_Schemes_Ombud_Service Act_en.mp3',
    audio_af: 'audio/af/Community_Schemes_Ombud_Service Act_af.mp3',
    audio_xh: 'audio/xh/Community_Schemes_Ombud_Service Act_xh.mp3'
  },
  {
    id: 3,
    name: 'Deeds Registries Act 47 of 1937',
    summary: 'shortsummary/Deeds Registries Act 47 of 1937.html',
    link: 'Deeds Registries Act 47 of 1937.pdf',
    audio_en: 'audio/en/Deeds Registries Act 47 of 1937_en.mp3',
    audio_af: 'audio/af/Deeds Registries Act 47 of 1937_af.mp3',
    audio_xh: 'audio/xh/Deeds Registries Act 47 of 1937_xh.mp3'
  },
  {
    id: 4,
    name: 'Development Facilitation Act (No. 67)',
    summary: 'shortsummary/Development Facilitation Act (No. 67).html',
    link: 'Development Facilitation Act_.pdf',
    audio_en: 'audio/en/Development Facilitation Act__en.mp3',
    audio_af: 'audio/af/Development Facilitation Act__af.mp3',
    audio_xh: 'audio/xh/Development Facilitation Act__xh.mp3'
  },
  {
    id: 5,
    name: 'Extension of Security of Tenure Act (ETSA)',
    summary: 'shortsummary/Extension of Security of Tenure Act (ETSA).html',
    link: 'Extension of Security of Tenure Act_.pdf',
    audio_en: 'audio/en/Extension of Security of Tenure Act__en.mp3',
    audio_af: 'audio/af/Extension of Security of Tenure Act__af.mp3',
    audio_xh: 'audio/xh/Extension of Security of Tenure Act__xh.mp3'
  },
  {
    id: 6,
    name: 'Home Loan and Mortgage Act',
    summary: 'shortsummary/home_loan_and_mortgage_act.html',
    link: 'Home Loan and Mortgage Disclosure Act.pdf',
    audio_en: 'audio/en/Home Loan and Mortgage Disclosure Act_en.mp3',
    audio_af: 'audio/af/Home Loan and Mortgage Disclosure Act_af.mp3',
    audio_xh: 'audio/xh/Home Loan and Mortgage Disclosure Act_xh.mp3'
  },
  {
    id: 7,
    name: 'HOUSING ACT 107 OF 1997',
    summary: 'shortsummary/Housing_Act_107_of_1997_0.html',
    link: 'Housing Act.pdf',
    audio_en: 'audio/en/Housing Act_en.mp3',
    audio_af: 'audio/af/Housing Act_af.mp3',
    audio_xh: 'audio/xh/Housing Act_xh.mp3'
  },
  {
    id: 8,
    name: 'Housing Consumer Act.pdf',
    summary: 'shortsummary/Housing Consumer Act.html',
    link: 'Housing Consumer Act.pdf',
    audio_en: 'audio/en/Housing_Consumer_Act_en.mp3',
    audio_af: 'audio/af/Housing_Consumer_Act_af.mp3',
    audio_xh: 'audio/xh/Housing_Consumer_Act_xh.mp3'
  },  
  {
    id: 9,
    name: 'Housing Act 107 of 1997_0',
    summary: 'shortsummary/Housing_Act_107_of_1997_0.html',
    link: 'Housing Act.pdf',
    audio_en: 'audio/en/Housing Act_en.mp3',
    audio_af: 'audio/af/Housing Act_af.mp3',
    audio_xh: 'audio/xh/Housing Act_xh.mp3'
  }, 
  {
    id: 10,
    name: 'Infrastructure Development Act (No. 23)',
    summary: 'shortsummary/Infrastructure Development Act (No. 23).html',
    link: 'Infrastructure development act_.pdf',
    audio_en: 'audio/en/Infrastructure development act__en.mp3',
    audio_af: 'audio/af/Infrastructure development act__af.mp3',
    audio_xh: 'audio/xh/Infrastructure development act__xh.mp3'
  },
  {
    id: 11,
    name: 'Prevention of Illegal Eviction from and Unlawful Occupation of Land Act 1998',
    summary: 'shortsummary/Prevention_of_Illegal_Eviction_from_and_Unlawful_Occupation_.html',
    link: 'Prevention of Illegal Eviction from and Unlawful Occupation of Land Act_.pdf',
    audio_en: 'audio/en/Prevention of Illegal Eviction from and Unlawful Occupation of Land Act__en.mp3',
    audio_af: 'audio/af/Prevention of Illegal Eviction from and Unlawful Occupation of Land Act__af.mp3',
    audio_xh: 'audio/xh/Prevention of Illegal Eviction from and Unlawful Occupation of Land Act__xh.mp3'
  },
  {
    id: 12,
    name: 'Prevention of illegal eviction',
    summary: 'shortsummary/Prevention_of_Illegal_Eviction_from_and_Unlawful_Occupation_.html',
    link: 'Prevention of Illegal Eviction from and Unlawful Occupation of Land Act_.pdf',
    audio_en: 'audio/en/Prevention of Illegal Eviction from and Unlawful Occupation of Land Act__en.mp3',
    audio_af: 'audio/af/Prevention of Illegal Eviction from and Unlawful Occupation of Land Act__af.mp3',
    audio_xh: 'audio/xh/Prevention of Illegal Eviction from and Unlawful Occupation of Land Act__xh.mp3'
  },
  {
    id: 13,
    name: 'Rental Housing Amendment No. 35 of 2014',
    summary: 'shortsummary/Rental Housing Act.html',
    link: 'Rental housing Amendment Act No 35 of 2014.pdf',
    audio_en: 'audio/en/Rental housing Amendment Act 43 of 2007_en.mp3',
    audio_af: 'audio/af/Rental housing Amendment Act 43 of 2007_af.mp3',
    audio_xh: 'audio/xh/Rental housing Amendment Act 43 of 2007_xh.mp3'
  },
  {
    id: 14,
    name: 'Rental housing Amendment Act No 35 of 2014',
    summary: 'shortsummary/Rental Housing Amendment No. 35 of 2014.html',
    link: 'Rental housing Amendment Act No 35 of 2014.pdf',
    audio_en: 'audio/en/Rental housing Amendment Act No 35 of 2014_en.mp3',
    audio_af: 'audio/af/Rental housing Amendment Act No 35 of 2014_af.mp3',
    audio_xh: 'audio/xh/Rental housing Amendment Act No 35 of 2014_xh.mp3'
  },
  {
    id: 15,
    name: 'Rental housing Amendment Act 43 of 2007',
    summary: 'shortsummary/Rental_Housing_Amendment_Act 43 of2007 pdf.html',
    link: 'Rental housing Amendment Act 43 of 2007.pdf',
    audio_en: 'audio/en/Rental housing Amendment Act 43 of 2007_en.mp3',
    audio_af: 'audio/af/Rental housing Amendment Act 43 of 2007_af.mp3',
    audio_xh: 'audio/xh/Rental housing Amendment Act 43 of 2007_xh.mp3'
  },
  {
    id: 16,
    name: 'Sectional Titles Schemes Management Act, 2011',
    summary: 'shortsummary/Sectional titles schemes ACt.html',
    link: 'Sectional titles schemes ACt.pdf',
    audio_en: 'audio/en/Sectional titles schemes ACt_en.mp3',
    audio_af: 'audio/af/Sectional titles schemes ACt_af.mp3',
    audio_xh: 'audio/xh/Sectional titles schemes ACt_xh.mp3'
  },
  {
    id: 17,
    name: 'Social Housing Act',
    summary: 'shortsummary/Social Housing Act.html',
    link: 'Social housing act.pdf',
    audio_en: 'audio/en/Social housing act_en.mp3',
    audio_af: 'audio/af/Social housing act_af.mp3',
    audio_xh: 'audio/xh/Social housing act_xh.mp3'
  },
  {
    id: 18,
    name: 'Upgrading of Land Tenure Rights Act',
    summary: 'shortsummary/Upgrading of Land Tenure Rights Act.html',
    link: 'Upgrading of Land Tenure Rights Act.pdf',
    audio_en: 'audio/en/Upgrading of Land Tenure Rights Act_en.mp3',
    audio_af: 'audio/af/Upgrading of Land Tenure Rights Act_af.mp3',
    audio_xh: 'audio/xh/Upgrading of Land Tenure Rights Act_xh.mp3'
  }
];